import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSession } from '../../contexts/SessionContext';

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isLoading, user } = useSession();

  // Reduced logging to prevent console spam
  if (process.env.NODE_ENV === 'development') {
    console.log('🔍 ProtectedRoute: Authentication state:', { isAuthenticated, isLoading });
    console.log('🔍 ProtectedRoute: Current location:', location.pathname);
    console.log('🔍 ProtectedRoute: User:', user?.name);
  }

  // Add a small delay to prevent rapid re-renders during navigation
  if (isLoading) {
    // Show loading state while session is being initialized
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        Loading session...
      </div>
    );
  }

  if (!isAuthenticated) {
    if (process.env.NODE_ENV === 'development') {
      console.log('❌ ProtectedRoute: Not authenticated, redirecting to login');
    }
    // Redirect to login page with the return url
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Additional check to ensure user data is available
  if (!user) {
    if (process.env.NODE_ENV === 'development') {
      console.log('❌ ProtectedRoute: No user data, redirecting to login');
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (process.env.NODE_ENV === 'development') {
    console.log('✅ ProtectedRoute: Authentication successful, rendering children');
  }
  return children;
};

export default ProtectedRoute; 